import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/breadcrum'
import { Link } from 'react-router-dom'
import AddItem from '../../components/addItem'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import {
  getCinImageFromFunding,
  getDeleteCompany,
  restoreCompany,
} from '../../api/fundingApi'
import { FaEye, FaEyeSlash, FaSearch } from 'react-icons/fa'

const Funding = () => {
  const queryClient = useQueryClient()
  const [showHidden, setShowHidden] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    document.title = 'Funding 365'
  }, [])

  const {
    data: funding365 = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['funding365Data', showHidden],
    queryFn: () => (showHidden ? getDeleteCompany() : getCinImageFromFunding()),
    onError: (error) => {
      toast.error('Error Fetching funding 365')
    },
  })

  const filteredUsers =
    funding365?.filter((funding) => {
      const matchesSearch = funding.companyName
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())

      return matchesSearch
    }) || []

  const restoreMutation = useMutation({
    mutationFn: (id) => restoreCompany(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['funding365Data'] })
      toast.success('Company restore sucessfully!')
    },
    onError: (err) => {
      console.error('restore report error:', err)
      toast.error(err.message || 'Failed to send verification email')
    },
  })

  if (isLoading) {
    return (
      <>
        <Breadcrum heading="Insight" subheading="funding 365" />
        <div className="text-center py-8">Loading funding 365...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum heading="Insight" subheading="funding 365" />
        <div className="text-center py-8 text-red-500">
          Error loading funding 365. Please try again later.
        </div>
      </>
    )
  }

  const handleToggle = () => {
    setShowHidden((prev) => !prev)
  }

  return (
    <>
      <Breadcrum subheading="funding 365" heading="Insight" />

      <div className="fixed right-10 top-[18%] bg-[#ff7010] rounded-full text-white text-xl w-fit h-fit px-2 py-1 shadow-md">
        {funding365.length}
      </div>

      {showHidden ? '' : <AddItem redirect="/dealdashboard/add/funding" />}

      {/* Search and Filter Section */}
      <div className="md:w-[90%] mx-auto my-6">
        <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Search by company name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#ff7010] focus:border-transparent outline-none transition-all"
              />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500">
            Showing {filteredUsers.length} of {funding365.length} Reports
          </div>
        </div>
      </div>

      <div className="md:w-[90%] mx-auto mb-5 flex justify-between items-center">
        <h2
          className={`text-2xl font-semibold ${
            showHidden ? 'text-red-600' : 'text-gray-600'
          }`}
        >
          {showHidden ? 'Hidden' : 'Active'} Companies
        </h2>

        <button
          onClick={handleToggle}
          title={showHidden ? 'Show active companies' : 'Show hidden companies'}
          className="text-white bg-blue-500 p-2 rounded hover:bg-blue-700 transition-colors"
        >
          {showHidden ? <FaEye /> : <FaEyeSlash />}
        </button>
      </div>

      <div className="md:w-[90%] mx-auto bg-[#FBFCFC] w-auto grid md:grid-cols-6 rounded gap-2">
        {filteredUsers.map((item) => (
          <div key={item.id} className="relative m-2">
            {showHidden ? (
              <>
                <button
                  onClick={() => restoreMutation.mutate(item.id)}
                  title="Restore Company"
                  className="absolute top-1 right-1 z-10 text-white bg-green-600 p-2 rounded hover:bg-green-800 transition-colors"
                >
                  <FaEye />
                </button>
                <img
                  src={item.companyLogoUrl}
                  alt={`Funding item ${item.cin}`}
                  className="w-full h-full rounded"
                />
              </>
            ) : (
              <Link to={`report/${item.id}`}>
                <img
                  src={item.companyLogoUrl}
                  alt={`Funding item ${item.cin}`}
                  className="w-full h-full rounded"
                />
              </Link>
            )}
          </div>
        ))}
      </div>
      {showHidden ? '' : <AddItem redirect="/dealdashboard/add/funding" />}
    </>
  )
}

export default Funding
